(function() {
    'use strict';

    const section = document.querySelector('.beatsync-feature');
    const media = document.querySelector('.beatsync-feature__media');
    const badge = document.querySelector('.beatsync-feature__badge');

    if (!section || !media || !badge) {
        return;
    }

    let ticking = false;

    const clamp = (value, min, max) => Math.min(max, Math.max(min, value));

    const updateBadgePosition = () => {
        ticking = false;

        if (window.innerWidth <= 991) {
            badge.style.removeProperty('--beatsync-badge-offset');
            return;
        }

        const sectionRect = section.getBoundingClientRect();
        const mediaHeight = media.offsetHeight;
        const badgeHeight = badge.offsetHeight;
        const maxTravel = Math.max(mediaHeight - badgeHeight, 0);

        const totalScrollDistance = window.innerHeight + sectionRect.height;
        const scrolledDistance = window.innerHeight - sectionRect.top;
        const progress = clamp(scrolledDistance / totalScrollDistance, 0, 1);
        const offset = Math.round(maxTravel * progress);

        badge.style.setProperty('--beatsync-badge-offset', offset + 'px');
    };

    const onScrollOrResize = () => {
        if (ticking) {
            return;
        }

        ticking = true;
        window.requestAnimationFrame(updateBadgePosition);
    };

    window.addEventListener('scroll', onScrollOrResize, {
        passive: true
    });
    window.addEventListener('resize', onScrollOrResize);
    updateBadgePosition();
})();
